var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"token-power-setting description"},[_c('span',{domProps:{"textContent":_vm._s(
      _vm.$t('trade.content.information.tokenPower.currentAllowance', {
        value: _vm.allowance,
      })
    )}})])}
var staticRenderFns = []

export { render, staticRenderFns }